var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"zidingyi_wenzi",style:(_vm.shu.yangshi)},[_vm._v("leibiao")])}
var staticRenderFns = []

export { render, staticRenderFns }